import styles from './SignInRegister.less';

import React, { Component } from 'react';

import SignInRegisterLink from 'SignInRegisterLink/SignInRegisterLink';
import { ScreenReaderOnly } from 'seek-style-guide/react';

export default class SignInRegister extends Component {

  render() {
    return (
      <nav data-automation="sign-in-register" className={styles.root}>

        <ScreenReaderOnly>
          <h1>Sign in or register</h1>
        </ScreenReaderOnly>

        <SignInRegisterLink mode="signin">Sign in</SignInRegisterLink>
        <span>&nbsp;or&nbsp;</span>
        <SignInRegisterLink mode="register">Register</SignInRegisterLink>

      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/SignInRegister/SignInRegister.js
 **/